
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/our-values",
      function () {
        return require("private-next-pages/severalbrands/our-values.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/our-values"])
      });
    }
  